module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-materials"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('material-usage')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('suppliers')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2efd2d41", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2efd2d41"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/materials.vue
// module id = 809
// module chunks = 0